module.exports = __webpack_public_path__ + "img/icon-fleche-bas-yellow-quest copie.d1543251.svg";